<!-- 添加商品到采购单 -->
<template>
    <div v-loading="loading">
        <div class="table-ctn" style="width: 65%;display: inline-block;">
            <el-table
                ref="purOrdersTable"
                :header-cell-style="{ background: '#F2F6FC' }"
                :row-key="getRowKeys"
                @selection-change="handleSelectionChange"
                :data="tableData"
                border
                height="550"
                :header-cell-class-name="cellClass"
            >
                <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="OrderCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="SuppName" label="供应商"></el-table-column>
            </el-table>
        </div>
        <div class="table-ctn" style="width: 30%;display: inline-block;float: right;">
            <el-form label-position="right" label-width="70px" size="small" :model="goodsForm">
                <el-form-item label="汽配编码">
                    <el-input v-model="goodsForm.APCode" disabled size="small" />
                </el-form-item>
                <el-form-item label="配件名称">
                    <el-input v-model="goodsForm.GoodName" disabled size="small" />
                </el-form-item>
                <el-form-item label="库存数">
                    <el-input v-model="goodsForm.Inventory" disabled size="small" />
                </el-form-item>
                <el-form-item label="留余数">
                    <el-input v-model="goodsForm.Remaining" disabled size="small" />
                </el-form-item>
                <el-form-item label="待入数">
                    <el-input v-model="goodsForm.POrderWaitInQuantity" disabled size="small" />
                </el-form-item>
                <el-form-item label="补订数">
                    <el-input :min="1" v-model="goodsForm.Count" ref="gf_0" size="small" style="width: 100%" type="number" @focus="selectAutoHandle('gf_0')" />
                </el-form-item>
                <el-form-item label="订货价">
                    <el-input :min="0" v-model="goodsForm.Price" ref="gf_1" size="small" style="width: 100%" type="number" @focus="selectAutoHandle('gf_1')" />
                </el-form-item>
                <el-form-item label="方式">
                    <el-select style="width: 100%" ref="gf_2" size="small" v-model="goodsForm.ActionType" placeholder="请选择方式" @visible-change="stopSumbit">
                        <el-option label="增加新单" value="0"></el-option>
                        <el-option label="并入旧单" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商">
                    <el-select
                        style="width: 100%"
                        size="small"
                        ref="gf_3"
                        v-model="goodsForm.EntpCusId"
                        remote
                        filterable
                        placeholder="请选择供应商"
                        :remote-method="searchSupplier"
                        v-select-scroll-more="searchSupplierLoad"
                        @visible-change="supplierVisibleChange($event)"
                        :disabled="goodsForm.ActionType == 1"
                    >
                        <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusId"></el-option>
                        <el-option v-if="supplierForm.loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="dialog-footer">
            <el-button class="btn-primary el-button" size="small" v-if="!loading" @click="btnConfirm">确认(Enter)</el-button>
            <el-button class="el-button" size="small" v-if="!loading" @click="btnClose">取消(ESC)</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['GoodsData'],
    components: {},
    data() {
        return {
            loading: false,
            gfIndex: 0,
            tableData: [],
            searchDataLength: 0,
            searchData: {
                CusId: '',
                StartDate: '',
                EndDate: '',
                Page: 1,
                Limit: 10
            },
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: '',
                loading: false
            },
            goodsForm: {
                OrderId: '',
                GoodsId: '',
                APCode: '',
                GoodName: '',
                Inventory: '',
                Count: 1,
                Price: 0,
                EntpCusId: '',
                ActionType: '0',
                Remaining: 0,
                POrderWaitInQuantity: 0
            }
        };
    },
    mounted() {
        this.goodsForm.GoodsId = this.GoodsData.EntpTempGoodsId;
        this.goodsForm.APCode = this.GoodsData.APCode;
        this.goodsForm.GoodName = this.GoodsData.GoodName;
        this.goodsForm.Inventory = this.GoodsData.Inventory;
        this.goodsForm.Price = this.GoodsData.CostPrice;
        this.goodsForm.POrderWaitInQuantity = this.GoodsData.POrderWaitInQuantity;
        this.goodsForm.Remaining = this.GoodsData.Remaining;
        this.getOrders();
        document.addEventListener('keydown', this.handleKeyEvent_dialog);
        this.$nextTick(() => {
            this.$refs.gf_0.focus();
            this.gfIndex = 0;
        });
    },
    methods: {
        handleKeyEvent_dialog(e) {
            let that = this;
           
            if (that.loading) return;
            let key = window.event.keyCode;
            if (key === 13) {
                //Enter
                e.preventDefault();
                if (
                    (!that.$refs.gf_2 || (that.$refs.gf_2 && !that.$refs.gf_2.visible)) &&
                    (!that.$refs.gf_3 || (that.$refs.gf_3 && !that.$refs.gf_3.visible)) &&
                    that.canSumbit
                ) {
                    that.btnConfirm();
                }
                that.canSumbit = true;
                
                return;
            }
            //下键
            if (key == 40) {
                e.preventDefault();
                if (that.gfIndex != 3) {
                    that.gfIndex += 1;
                    if (that.$refs[`gf_` + that.gfIndex]) that.$refs[`gf_` + that.gfIndex].focus();
                }
                return;
            }
            //上键
            if (key == 38) {
                e.preventDefault();
                if (that.gfIndex != 0) {
                    that.gfIndex -= 1;
                    if (that.$refs[`gf_` + that.gfIndex]) that.$refs[`gf_` + that.gfIndex].focus();
                }
                return;
            }
             
        },
        stopSumbit() {
            this.canSumbit = false;
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            //每次点击搜索配件后打开弹窗，select()事件没效果，有可能初始化控件后这个事件还没监听到input控件
            //所以这里用来nextTick 和 setTimeout做双重保证
            this.$nextTick(() => {
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                }, 100);
            });
        },
        btnClose() {
            document.removeEventListener('keydown', this.handleKeyEvent_dialog);
            this.$emit('closeDialog');
        },
        cellClass(row) {
            if (row.columnIndex === 0 && row.rowIndex === 0) {
                return 'disableheadselection';
            }
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.OrderId;
        },
        handleSelectionChange(selection) {
            if (selection.length == 1) {
                this.goodsForm.OrderId = selection[0].OrderId;
            } else if (selection.length > 1) {
                const del_row = selection.shift();
                this.goodsForm.OrderId = del_row.OrderId;
                this.$refs.purOrdersTable.toggleRowSelection(del_row, false);
            } else {
                this.goodsForm.OrderId = '';
            }
        },
        getOrders() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetNotSubmPurOrderList',
                    hideLoading: true,
                    data: this.searchData
                })
                .then(res => {
                    if (!res.data) return;
                    this.tableData = res.data;
                    // this.searchDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getOrders();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getOrders();
        },
        handleSearch() {
            this.getOrders();
        },
        //当供应商下拉框出现时触发
        supplierVisibleChange(event) {
            let that = this;
            that.stopSumbit();
            if (event) {
                if (that.supplierOptions.length <= 1) that.searchSupplier('');
            }
        },
        // 搜索供应商，分页
        searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.supplierForm.loading = true;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                this.supplierForm.loading = false;
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = this.$util.uniqueArr(this.supplierOptions, data);
            });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        //关闭前
        beforeColse() {
            if (!this.loading) {
                this.btnClose();
            }
        },
        btnConfirm() {
            let that = this;
            if (that.loading) return;
            if (that.goodsForm.ActionType == 1) {
                if (!that.goodsForm.OrderId) {
                    this.$util.warningMsg('请选择旧单');
                    return;
                }
            }
            if (parseInt(that.goodsForm.Count) <= 0) {
                this.$util.warningMsg('补订数不能小于等于零');
                return;
            }
            if (that.goodsForm.ActionType == 0 && !that.goodsForm.EntpCusId) {
                this.$util.warningMsg('请选择供应商');
                return;
            }

            that.loading = true;
            let url = '/api/EntpPurchaseOrder/AddGoodsToOrder';
            that.$util
                .axiosPost({
                    url: url,
                    data: that.goodsForm,
                    hideLoading: true
                })
                .then(resp => {
                    that.$util.successMsg(resp.errmsg);
                    that.btnClose();
                    that.$emit('closeDialog');
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-footer {
    text-align: right;
    margin-top: 10px;
}
.table-ctn .el-table {
    margin-bottom: 0px;
}
/deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none;
}
</style>
